import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import ChecklistTable from "./ChecklistTable";
import useAxios from "axios-hooks";
import DeleteChecklistModal from "./DeleteChecklistModal";
import { Spinner } from "@fluentui/react";
import CloneChecklistModal from "./CloneChecklistModal";
import {useBoolean} from "@fluentui/react-hooks";

const ChecklistList = () => {
  const [selectedChecklistId, setSelectedChecklistId] = useState(undefined);
  const [selectedChecklistName, setSelectedChecklistName] = useState(undefined);
  const [selectedChecklistStatus, setSelectedChecklistStatus] = useState(undefined);
  const history = useHistory();
  let { url } = useRouteMatch();

    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);
    const [showCloneModal, { toggle: toggleCloneModal }] = useBoolean(false);


  const [{ data, loading }, refetch] = useAxios("checklists");

  if (loading)
    return <Spinner className="absolute-center" label="Loading Checklist..." />;

  return (
    <>
      <ChecklistTable
        checklists={data}
        setSelectedChecklistId={setSelectedChecklistId}
        setSelectedChecklistName={setSelectedChecklistName}
        selectedChecklistId={selectedChecklistId}
        createOnClick={() => history.push(`${url}/wizard`)}
        cloneOnClick={(id) => {
          setSelectedChecklistId(id);
          toggleCloneModal();
        }}
        deleteOnClick={(id, name, status) => {
          setSelectedChecklistId(id);
          setSelectedChecklistName(name);
          setSelectedChecklistStatus(status);
          toggleDeleteModal();
        }}
        editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
        editActionItems={(id) => history.push(`${url}/${id}/action-items`)}
        onOffSettingsOnClick={(id) =>
          history.push(`${url}/${id}/on-off-settings`)
        }
        previewOnClick={(id) => history.push(`${url}/${id}/preview`)}
        refetch={refetch}
        loading={loading}
      />
      <CloneChecklistModal
        checklistId={selectedChecklistId}
        showModal={showCloneModal}
        toggleShowModal={toggleCloneModal}
        onClone={() => refetch()}
        onNavigate={(id) => history.push(`${url}/${id}/wizard`)}
      />
      <DeleteChecklistModal
        checklistId={selectedChecklistId}
        showModal={showDeleteModal}
        toggleShowModal={toggleDeleteModal}
        onDelete={() => refetch()}
        checklistName={selectedChecklistName}
        checklistStatus={selectedChecklistStatus}
      />
    </>
  );
};

export default ChecklistList;
